import * as React from 'react';
import ThemeControls from "../AllThemesControl";
import Button           from '../../FormsControls/Button';
import Element          from '../../FormsControls/Element';
import { FormContext }  from '../Forms/FormContext';
import CloseIcon from '@mui/icons-material/Close';

import elementValidation from '../validation.js';

//APIService 
import {APIPATCH, APIPOST} from '../../services/APIServices';
import { ConstructionOutlined } from '@mui/icons-material';


const json = {
  "fields": [
    {
      "field_id":"comments",
      "field_label":"Comments",
      "field_mandatory":"yes",
      "field_placeholder":"",
      "field_type":"multilineText", 
      "field_value":"",
      "field_minlength":"",
      "field_maxlength":"",
      "field_minvalue":"",
      "field_maxvalue":"",
      "field_value_type":"",
      "field_on_blur":"",
      "field_error_msg_required":"",
      "field_error_msg_minlength":"",
      "field_error_msg_maxlength":"",
      "field_error_msg_minvalue":"",
      "field_error_msg_maxvalue":"",
      "field_error_msg_uq":""
     }
  ]
};
export default function ApproveRejectComment(props){ 
    // const [value,setValue] = React.useState("");
    const {useStyles} = ThemeControls;
    const [data,setData] = React.useState();
    const selected=props.selected;
    const [elements,setElements] = React.useState(json.fields);
    const path = props.path;
    const apiContextObj = props.apiContextObj;
    const classes = useStyles();
    const [btnLoading, setBtnLoading] = React.useState(false);
    //==>    
    const {dataArr, dataRow, indexPer} = props;


    React.useEffect(() => {
      const newElements = json.fields.map((field, i) => {
        // Modify the field object
        return {
          ...field,
          field_value: "",
          field_helperText: ""
        };
      });
      setElements(newElements);
    }, []);
    

    //handle change==>
    const handleChange = (id,event,valueStr) => {
        const newElements = [...elements]
        newElements.forEach(field => {
          const { field_type, field_id } = field;
          if (id === field_id) {
            switch (field_type) {
              case 'checkbox':
                field['field_value'] = event.target.checked;
                break;

              default:
                field['field_value'] = valueStr;
                //console.log(valueStr)
                break;
            }
          }
          setElements(newElements);
        });
      }
      function handleSuccessMsg(res) {
        if (res.dataRecevied.statusCode = "SUCCESS") {
          props.setErrorMsg(`Successfully ${path}`)
          props.setErrorOpen(true)
          props.setOpen(false)
          props.setSelected([])
          props.close()
        }
      }
      console.log(selected)
    //Handle Deletion ===>
    const createData = (dataObj) => {
     
   const  tempData = selected.map((field) => ({
          ratesheetmisid: field.ratesheetmisid,
          ratesheetmisrequestid: field.ratesheetmisrequestid,
          comments: elements[0].field_value
      }));
      return tempData;
    };
    function ErrorMSg(msg){
      alert(msg)
      setBtnLoading(false)
    }
    const handleSubmit = async () => {
      setBtnLoading(true)
      let validData = true;
      let apiPath = '';
      if (path === 'approve') {
        apiPath = apiContextObj.approveRejectFlow.apiContextApprove.apiContext;
      } else if (path === 'reject') {
        apiPath = apiContextObj.approveRejectFlow.apiContextReject.apiContext;
      }

      elements?.forEach((field,index)=>{
        if(!elementValidation(field)){
          validData = false;
        }
      });

      if(validData && selected.length>0){
        try {
          const data = createData({});

          const response = await APIPOST(apiPath, data, props.contextJson, handleSuccessMsg, ErrorMSg);
           
          setData(response.data);
        } catch (error) {
          console.error(error);
        }
      }else{
        setBtnLoading(false)
      }
    }
    
    const handleCancel=()=>{
      props.close();
    }
      return(
        <>
         <div className={classes.closeup}>
              <CloseIcon onClick={()=>(handleCancel())}/>
              <div className={classes.bdr}>
              <h4>{path=='approve'?'Approve':'Reject'}</h4>
              <div></div>
              </div>
            </div>
            <div className={classes.preview}>
              {/* <div className={classes.pt105}>
              </div> */}
              <FormContext.Provider value={{handleChange}}>
                      <div className='App containers'>
                          {/* <DeleteLabel/> */}
                          {elements?elements.map((field,i)=><Element key={i} field={field}/>):null}
                             
                      </div>
              </FormContext.Provider>
              <div className={classes.tps}> 
                <Button ButtonName="Cancel" onClick={()=>(handleCancel())}/>
                <Button field_disabled={btnLoading} ButtonName= {btnLoading?
                  <div class={classes.loading08}>
                    <span data-text="L">L</span>
                    <span data-text="O">O</span>
                    <span data-text="A">A</span>
                    <span data-text="D">D</span>
                    <span data-text="I">I</span>
                    <span data-text="N">N</span>
                    <span data-text="G">G</span>
                  </div>:"Submit"} onClick={()=>(handleSubmit())} />
              </div>
          </div>
        </>
      )
}

